

export class SelectedPortForVehicleOutput implements ISelectedPortForVehicleOutput {
    /** The auto-generated id of the device selected port master */
    device_selected_port_id!: number;
    /** The auto-generated id of the device port specification master master */
    device_model_port_specification_id!: number;
    /** The property name should be 255 character */
    property_name!: string;

    constructor(data?: ISelectedPortForVehicleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_selected_port_id = _data["device_selected_port_id"];
            this.device_model_port_specification_id = _data["device_model_port_specification_id"];
            this.property_name = _data["property_name"];
        }
    }

    static fromJS(data: any): SelectedPortForVehicleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedPortForVehicleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_selected_port_id"] = this.device_selected_port_id;
        data["device_model_port_specification_id"] = this.device_model_port_specification_id;
        data["property_name"] = this.property_name;
        return data; 
    }
}

export interface ISelectedPortForVehicleOutput {
    /** The auto-generated id of the device selected port master */
    device_selected_port_id: number;
    /** The auto-generated id of the device port specification master master */
    device_model_port_specification_id: number;
    /** The property name should be 255 character */
    property_name: string;
}

